import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 50px;
`;

export const Logo = styled.img`
  width: 125px;
`;

export const Title = styled.div`
  font-family: Poppins-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 33px;
  text-align: center;
  color: #626262;
  width: 100%;
  margin-top: 15px;
`;

export const BlueTitle = styled.span`
  font-family: Poppins-Bold;
  font-weight: 700;
  color: #D40020;
`;

export const SubTitle = styled.div`
  font-family: Poppins-Regular;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #3C3B3B;
  margin-top: 50px;

  @media screen and (max-width: 767px) {
    margin-top: 20px;
  }
`;
